import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SaveChangesDialogModel, SaveChangesResult } from './generic-dialogs.model';

@Component({
	template: `
		<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
			<h1 mat-dialog-title cdkDragHandle>{{ title }}</h1>
		</div>

		<div mat-dialog-content>
			<p>{{ message }}</p>
		</div>

		<div mat-dialog-actions align="end">
			<button [disabled]="!canBeSaved" (click)="saveChanges()" mat-stroked-button color="primary">Save</button>
			<button (click)="discardChanges()" mat-stroked-button color="warn">Discard</button>
			<button (click)="cancel()" mat-stroked-button>Cancel</button>
		</div>
	`,
	imports: [CommonModule, DragDropModule, MatButtonModule, MatDialogModule],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveChangesDialogComponent {
	title: string;
	message: string;
	canBeSaved: boolean;

	constructor(
		public dialogRef: MatDialogRef<SaveChangesDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: SaveChangesDialogModel,
	) {
		this.title = 'Save changes?';
		this.message = data.overrideText || `This ${data.typeName.toLowerCase()} has unsaved changes.`;
		if (data.form) {
			this.canBeSaved = data.form.valid;
		} else {
			this.canBeSaved = true;
		}
	}

	@HostListener('document:keydown.s')
	saveChanges() {
		if (!this.canBeSaved) {
			return;
		}
		this.dialogRef.close(SaveChangesResult.Save);
	}

	@HostListener('document:keydown.d')
	discardChanges() {
		this.dialogRef.close(SaveChangesResult.Discard);
	}

	cancel() {
		this.dialogRef.close(SaveChangesResult.Cancel);
	}
}
